import React from 'react';
import "./Spinner.css";

function Spinner() {
	return (<div className="loadingio-spinner-bean-eater-nbsqhr5av5j"><div className="ldio-4z8qem0ul76">
	<div><div></div><div></div><div></div></div><div><div></div><div></div><div></div></div>
	</div></div>)
}

export default Spinner;